<template>
  <div class="report-generator container">
    <div class="report-generator__wrapper">
      <h1 class="report-generator__page-title">Gerar relatório</h1>

      <Select
        :data-list="reportList"
        :pre-selected="$route.query.tipo"
        @valueSelected="getValue"
      />

      <MicrobiologyReport
        v-if="parcialMicrobiologyReport"
        @noResultsFound="showModal"
      />
      <Recollect
        v-if="recollects"
        @noResultsFound="showModal"
      />
      <PendingSamples
        v-if="pendingSamplesReport"
        @noResultsFound="showModal"
      />
      <Reschedule
        v-if="reschedule"
        @noResultsFound="showModal"
      />
      <PanicReport
        v-if="panicReport"
        @noResultsFound="showModal"
      />

      <RegisteredExams
        v-if="registeredExams"
        @noResultsFound="showModal"
      />

      <div
        v-if="verifyButton"
        class="report-generator__fake-button"
      >
        <button
          class="btn btn-primary btn-regular-size"
          :disabled="verifyButton"
        >
          Gerar relatório
        </button>
      </div>
    </div>

    <ReportGeneratorModalFeedback
      :visible="isModalVisible"
      @closeModal="isModalVisible = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Select from '@/components/common/Select'
import MicrobiologyReport from '@/components/ReportGenerator/Microbiology/MicrobiologyReport'
import ReportGeneratorModalFeedback from '@/components/ReportGenerator/ReportGeneratorModalFeedback'
import Recollect from '@/components/ReportGenerator/Recollects/Recollects'
import PendingSamples from '@/components/ReportGenerator/PendingSamples/PendingSamples'
import Reschedule from '@/components/ReportGenerator/Reschedule/Reschedule'
import PanicReport from '@/components/ReportGenerator/PanicReport/PanicReport'
import RegisteredExams from '@/components/ReportGenerator/RegisteredExams/RegisteredExams'

export default {
  name: 'ReportGeneratorMainView',
  components: {
    Select,
    MicrobiologyReport,
    Recollect,
    ReportGeneratorModalFeedback,
    PendingSamples,
    Reschedule,
    PanicReport,
    RegisteredExams,
  },
  data: () => {
    return {
      reportList: {
        id: 'report-type-select',
        label: 'Selecione o tipo de relatório e os filtros para exportação:',
        placeholder: 'Selecione o tipo de relatório',
        options: [
          {
            name: 'microbiology',
            text: 'Resultados parciais de microbiologia',
            featureToggle: 'microbiologyReport',
          },
          {
            name: 'recoletas',
            text: 'Gestão de Recoletas',
            featureToggle: 'recollectReport',
          },
          {
            name: 'amostras',
            text: 'Gestão de Amostras Não Recebidas',
            featureToggle: 'pendingSamplesReport',
          },
          {
            name: 'remarcação',
            text: 'Gestão de Remarcações',
            featureToggle: 'rescheduledReport',
          },
          {
            name: 'panico',
            text: 'Relatório de Pânico',
          },
          {
            name: 'exames',
            text: 'Exames Cadastrados',
          },
        ],
      },
      reschedule: false,
      recollects: false,
      parcialMicrobiologyReport: false,
      pendingSamplesReport: false,
      panicReport: false,
      registeredExams: false,
      isModalVisible: false,
    }
  },
  computed: {
    ...mapGetters(['profile']),
    verifyButton() {
      if (
        this.parcialMicrobiologyReport ||
        this.recollects ||
        this.pendingSamplesReport ||
        this.reschedule ||
        this.panicReport ||
        this.registeredExams
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    getValue(value) {
      const reportTypes = [
        'parcialMicrobiologyReport',
        'recollects',
        'pendingSamplesReport',
        'reschedule',
        'panicReport',
        'registeredExams',
      ]

      reportTypes.forEach(type => {
        this[type] = false
      })

      const reportMap = {
        microbiology: 'parcialMicrobiologyReport',
        recoletas: 'recollects',
        amostras: 'pendingSamplesReport',
        remarcação: 'reschedule',
        panico: 'panicReport',
        exames: 'registeredExams',
      }

      if (reportMap[value.name]) {
        this[reportMap[value.name]] = true
      }

      this.submitAnalyticsEvent(value.text)
    },
    showModal() {
      this.isModalVisible = true
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Gerar Relatórios',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  margin: 60px 0 60px 50px;
  padding: 50px 8%;
  position: relative;
}

.report-generator {
  font-family: 'Exo 2' !important;

  &__wrapper {
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
  }

  &__page-title {
    font-weight: 500;
    font-size: 26px;
    color: #7a7a7a;
    margin-bottom: 15px;
  }

  &__fake-button {
    display: flex;
    justify-content: flex-end;

    button {
      font-family: 'Exo 2' !important;
      margin-top: 56px;
    }
  }
}
</style>
